import { Injectable } from '@angular/core'
import { ICustomProduct } from '../../../models/interface/product.interface'
import { SharedService } from '../../../services/shared/shared.service'

@Injectable({ providedIn: 'root' })
export class CustomProductReplacementService {
  constructor(private sharedService: SharedService) {}

  /**
   * baseSiteId equals asaleocare-au or asaleocare-nz. Check if product is discontinued and if discontinued in 'Both' regions or
   * in '-au' or '-nz' regions
   * @param currentProduct
   */
  public isDiscontinuedRegion(currentProduct: ICustomProduct): boolean {
    return (
      currentProduct.discontinuedProduct &&
      (currentProduct?.discountinuedProductRegion === 'Both' ||
        this.sharedService.baseSiteId.toUpperCase().includes('-' + currentProduct?.discountinuedProductRegion))
    )
  }
}
